import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/shared/ui/toaster.jsx";
import { AuthProvider } from "@/features/auth/auth-context.jsx";
import { ApiError } from "@/api/client.js";

/**
 * Provedores globais do app, montados uma vez na raiz.
 */
export function AppProviders({ children }) {
  // useState garante um QueryClient por montagem — criar no corpo do
  // componente recriaria o cache a cada render.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: (falhas, erro) => {
              // Não insiste em erro de permissão ou dado inexistente.
              if (erro instanceof ApiError && erro.status < 500) return false;
              return falhas < 2;
            },
          },
          mutations: { retry: false },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
